import * as React from "react";
import { inject,observer } from 'mobx-react';
import ModelStore from 'src/stores/ModelStore';
import './NavigationComponent.scss';
import IMenuItem from "src/interfaces/IMenuItem";

interface IProps {
  modelStore?: ModelStore;
  index: number,
  model: IMenuItem
}
@inject("modelStore")
@observer
export default class MainNavigationItemComponent extends React.Component<IProps,{}> {

constructor(props?:any, state?:any){
    super(props,state);
    this.clickItem=this.clickItem.bind(this);
} 

  public render() {
     const modelStore = this.props.modelStore;
     const model = this.props.model;
      return (
        <div onClick={this.clickItem} className={  (model === modelStore!.selectedMenu) ? "menu-item active" : "menu-item"}  ><span className="num">{ this.props.index +1 }.</span><span className="label">{ model.title }</span></div>
    ); 
  }
  
  
  private clickItem (){
    const modelStore = this.props.modelStore as ModelStore;
    modelStore.setSelectedIndex(this.props.model.index);
  }
  


}


// WEBPACK FOOTER //
// ./src/components/MainNavigationItemComponent.tsx